"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _momentTimezone = _interopRequireDefault(require("moment-timezone"));

var _material = require("@mui/material");

var _ui = require("@alycecom/ui");

var _schedulePresets = require("./schedulePresets");

var styles = {
  menuList: {
    padding: 0
  },
  menuItem: {
    py: 1.5,
    px: 3
  },
  menuItemCustom: {
    borderTop: '1px solid',
    borderColor: 'divider',
    height: 61,
    justifyContent: 'center'
  }
};

var PresetScheduleForm = function PresetScheduleForm(_ref) {
  var onSelectPreset = _ref.onSelectPreset,
      onSelectCustom = _ref.onSelectCustom;

  var _generatePresets = (0, _schedulePresets.generatePresets)(),
      presets = _generatePresets.presets,
      timeZoneName = _generatePresets.timeZoneName;

  var handleSelectOption = (0, _react.useCallback)(function (event) {
    event.stopPropagation();
    event.preventDefault();
    var time = event.currentTarget.dataset.time;
    var momentTime = time ? (0, _momentTimezone.default)(time) : '';
    onSelectPreset(momentTime && momentTime.format());
  }, [onSelectPreset]);
  return /*#__PURE__*/_react.default.createElement(_material.Box, {
    minWidth: 372
  }, /*#__PURE__*/_react.default.createElement(_material.Box, {
    display: "flex",
    flexDirection: "column",
    pt: 3,
    pb: 1.5,
    px: 3
  }, /*#__PURE__*/_react.default.createElement(_material.Typography, {
    className: "H4-Chambray"
  }, "Schedule invite"), /*#__PURE__*/_react.default.createElement(_material.Box, {
    color: "grey.main",
    fontSize: "0.875rem"
  }, timeZoneName)), /*#__PURE__*/_react.default.createElement(_material.MenuList, {
    sx: styles.menuList
  }, presets.map(function (_ref2) {
    var name = _ref2.name,
        time = _ref2.time;
    return /*#__PURE__*/_react.default.createElement(_material.MenuItem, {
      key: name,
      sx: styles.menuItem,
      onClick: handleSelectOption,
      "data-preset": name,
      "data-time": time.format()
    }, /*#__PURE__*/_react.default.createElement(_material.Box, {
      width: "100%",
      display: "flex",
      flexDirection: "row",
      justifyContent: "space-between",
      alignItems: "center"
    }, name, /*#__PURE__*/_react.default.createElement(_material.Box, {
      color: "grey.main",
      fontSize: "0.875rem"
    }, /*#__PURE__*/_react.default.createElement(_ui.DateFormat, {
      value: time,
      timezone: "US/Eastern",
      format: "MMM DD, hh:mm A"
    }))));
  }), /*#__PURE__*/_react.default.createElement(_material.MenuItem, {
    onClick: onSelectCustom,
    sx: [styles.menuItem, styles.menuItemCustom],
    "data-preset": "None",
    "data-time": ""
  }, /*#__PURE__*/_react.default.createElement(_material.Box, {
    width: "100%",
    display: "flex",
    flexDirection: "row",
    alignItems: "center"
  }, /*#__PURE__*/_react.default.createElement(_ui.Icon, {
    icon: "calendar-alt",
    color: "inherit"
  }), /*#__PURE__*/_react.default.createElement(_material.Box, {
    ml: 1,
    display: "inline-block"
  }, "Pick Custom Date & Time")))));
};

var _default = PresetScheduleForm;
exports.default = _default;